import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { useCsReviewScores } from '@/lib/api/cs-reviews';
import { useFeedback } from '@/lib/api/feedback';

function DraftReviewScores() {
  const scoresQuery = useCsReviewScores();
  const weeks = scoresQuery.data ?? [];

  return (
    <div className="space-y-2">
      <h2 className="text-lg font-semibold tracking-tight">Draft review scores</h2>
      <p className="text-sm text-[var(--color-muted-foreground)]">
        Weekly average of the 1-5 scores CS gives the Intercom drafter on /review.
      </p>
      {scoresQuery.isError && (
        <p className="text-sm text-[var(--color-destructive)]">
          Failed to load scores: {scoresQuery.error.message}
        </p>
      )}
      <div className="rounded-md border">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Week of</TableHead>
              <TableHead>Reviews</TableHead>
              <TableHead>Accuracy</TableHead>
              <TableHead>Style</TableHead>
              <TableHead>Judgement</TableHead>
              <TableHead>Match</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {weeks.length ? (
              weeks.map((week) => (
                <TableRow key={week.weekStart}>
                  <TableCell className="font-medium">{week.weekStart}</TableCell>
                  <TableCell className="tabular-nums">{week.reviews}</TableCell>
                  <TableCell className="tabular-nums">{week.accuracy.toFixed(2)}</TableCell>
                  <TableCell className="tabular-nums">{week.style.toFixed(2)}</TableCell>
                  <TableCell className="tabular-nums">{week.judgement.toFixed(2)}</TableCell>
                  <TableCell className="tabular-nums">{week.match.toFixed(2)}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={6} className="h-16 text-center">
                  {scoresQuery.isPending ? 'Loading…' : 'No scored reviews yet.'}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}

export function FeedbackPage() {
  const feedbackQuery = useFeedback();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Feedback</h1>
        <p className="text-sm text-[var(--color-muted-foreground)]">
          Recent user messages the classifier flagged as feedback on an agent reply.
        </p>
      </div>

      <DraftReviewScores />

      <div>
        {feedbackQuery.isPending && <p className="text-sm">Loading…</p>}
        {feedbackQuery.isError && (
          <p className="text-sm text-[var(--color-destructive)]">
            Failed to load feedback: {feedbackQuery.error.message}
          </p>
        )}
        {feedbackQuery.data && (
          <div className="rounded-md border">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Category</TableHead>
                  <TableHead>Session</TableHead>
                  <TableHead>Reply seq</TableHead>
                  <TableHead>When</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {feedbackQuery.data.length ? (
                  feedbackQuery.data.map((item) => (
                    <TableRow key={item.id}>
                      <TableCell className="font-medium">{item.category}</TableCell>
                      <TableCell className="font-mono text-xs">{item.sessionId}</TableCell>
                      <TableCell className="tabular-nums">{item.targetMessageSeq ?? '—'}</TableCell>
                      <TableCell className="text-sm">
                        {new Date(item.createdAt).toLocaleString()}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} className="h-24 text-center">
                      No feedback yet.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
        )}
      </div>
    </div>
  );
}
